<template>
  <div class="w-full h-full flex items-stretch relative">
    <input
      @input="$emit('input', number)"
      v-validate="'required|min:13|max:20'"
      name="barcode"
      v-model="number"
      ref="inputNumber"
      style="font-size: 16px"
      class="h-full border-0 w-full px-2 bg-transparent text-center font-family"
      :class="{
        'border-danger': errors.first('barcode'),
        'rounded-l-lg': errors.first('barcode'),
        'rounded-lg': !errors.first('barcode')
      }"
      type="text"
      @keyup="addNumber($event)"
    />
    <div
      class="px-2 flex items-center cursor-pointer border-danger rounded-r-lg border-left-0"
      :class="{ _info: isToolTip }"
      v-if="errors.first('barcode')"
      @click="isToolTip = !isToolTip"
    >
      <feather-icon class="text-danger" icon="InfoIcon" svgClasses="w-5 h-5" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      isToolTip: false,
      listNumbers: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
      number: this.value,
      copyNumber: this.value
    };
  },
  watch: {
    "errors.items": async function () {
      const vmId = this.errors.vmId;
      const items = this.errors.items;

      const element = items.find(item => item.vmId === vmId);
      if (!element) return (this.isToolTip = false);
    }
  },
  methods: {
    /**
     * Agrega y valida los valores de entrada para armar el código de barra
     * @param {event} event - eEnvento de la acción
     */
    addNumber(event) {
      const element = this.$refs.inputNumber;
      if (this.listNumbers.includes(event.key)) {
        if (this.number.length === 1 && this.number === "0") this.number = "";
        else {
          if (element.selectionStart === 1 && element.selectionEnd === 1) {
            this.copyNumber = event.key;
          } else this.copyNumber += event.key;
        }
        this.number = this.copyNumber;
      } else {
        if (event.key === "Backspace" || event.key === "Delete") {
          if (element.selectionStart === 0 && element.selectionEnd === this.number.length) {
            this.number = "";
            this.copyNumber = "";
          } else {
            this.copyNumber = this.removeFormatter(this.number);
          }
        }
        this.number = this.copyNumber;
      }
    },
    /**
     * Remueve los puntos y apostrofes
     * @param {string} number
     */
    removeFormatter(number) {
      let result = number.replace(/[',.]/g, "");
      return result;
    }
  }
};
</script>

<style lang="scss" scoped>
.font-family {
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  font-weight: 400;
}

.border-danger {
  border: 1px solid rgba(234, 84, 85, 1) !important;
}

.border-left-0 {
  border-left: none !important;
}

._info::before {
  content: "El valor debe ser mínimo de 13 y máximo de 20 car\00E1\03F2teres.";
  position: absolute;
  width: 97%;
  left: 0;
  top: 36px;
  background-color: black;
  color: white;
  padding: 5px;
  z-index: 1;
  border-radius: 0.5rem !important;
}
</style>
